import type { ReactNode } from 'react';
import { Component } from 'react';
import type { IBreadcrumbItem } from '../elements/common';
import { Breadcrumb } from '../elements/common';

/**
 * @deprecated use PageTemplate instead
 */
export class SideBarTemplate extends Component<
    {
        breadcrumb?: IBreadcrumbItem[];
        children: ReactNode;
        groupBlock?: JSX.Element;
        infoBlock?: JSX.Element;
        navigation?: JSX.Element;
        sideBar?: JSX.Element;
    },
    {}
> {
    public render() {
        return (
            <div className="container">
                <div className="row">
                    {this.props.breadcrumb && (
                        <div className="col-sm-24">
                            <Breadcrumb items={this.props.breadcrumb} />
                        </div>
                    )}
                    {this.props.navigation && (
                        <div className="col-sm-6">
                            <div className="block-white">{this.props.infoBlock}</div>
                            <div className="block-white">{this.props.navigation}</div>
                        </div>
                    )}
                    {this.props.groupBlock && (
                        <div className="col-sm-6">
                            <div className="block-white">{this.props.groupBlock}</div>
                        </div>
                    )}
                    {this.props.sideBar && (
                        <div className="col-sm-6">
                            <div className="aside-wrapper">{this.props.sideBar}</div>
                        </div>
                    )}
                    <div className="col-sm-17 offset-sm-1">{this.props.children}</div>
                </div>
            </div>
        );
    }
}
